
define('modules/application/wizard/classes/deinserters',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericEnabler"

  ],

  function(app, Backbone, genericEnabler) {

    var deinserters = _.extend({}, genericEnabler, {

      Views: {
        titleBar: genericEnabler.Views.titleBar.extend(),
        content: genericEnabler.Views.content.extend()
      },

      Model: genericEnabler.Model.extend({
        defaults: _.extend({
          name: "IDS_WAI8_7",
          quote: "IDS_WAI1001_9012",
          value: false
        }, genericEnabler.Model.prototype.defaults),
        initialize: function() {
          genericEnabler.Model.prototype.initialize.apply(this);

          this.bind("change:value", this.valueChangedEventHandler, this);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);
        },

        valueChangedEventHandler: function() {
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },
        retrieveProducts: function() {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(407, function(data) {
              var packages = data.packages;
              if (packages.length > 0) {
                _.extend(that.attributes, packages[0]);
                BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[0].packageClassId, function(data) {
                  data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                  var products = _.filter(data.products, function(product) {
                    return product.mnemonic === 1;
                  });
                  var secondaryProducts = _.filter(data.products, function(product) {
                    return product.mnemonic !== 1;
                  });

                  if (products.length > 0) {
                    _.extend(that.attributes, products[0]);
                  }

                  that.set("secondaryProducts", secondaryProducts);
                  window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
                });
              }
            });
          }
        },

        deliverCurrent: function() {
          if (this.get("specialVars")) {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
            var currentConsumption = $.parseJSON(this.get("specialVars")).currentConsumption;

            if (this.get("value")) {
              if (currentConsumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
            }
          }
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.deinserters = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.deinserters = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.deinserters = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.deinserters = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.deinserters = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.deinserters = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("deinserters", this);
        }

      })
    });

    // Required, return the module for AMD compliance
    return deinserters;

  });